import Image from 'next/image';
import photo from '../../public/artem.jpg';

const ArtemTeamMember = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mt-16 mb-16 mx-4 md:mx-24">
      <div className="mb-10 md:mb-0">
        <Image
          src={photo}
          alt="Artem Grebenko"
          className="w-48 h-48 rounded-full"
        />
      </div>
      <div className="md:w-2/3 md:pl-10">
        <h2 className="text-3xl font-bold mb-5">Designer</h2>
        <p className="mb-5">
          Artem Grebenko is a graphic design professional with over 12 years of
          experience. My specializations include website design, promotional
          products, and creating engaging illustrations. I have excellent skills
          in using Adobe PhotoShop and Illustrator programs, which allow me to
          take a creative approach to each project.
        </p>
        <p className="mb-5">
          My expertise is not limited to graphic design, as I am also able to
          work with a variety of animation programs such as AfterEffects and
          Adobe Animate, and have experience with CorelDraw. My knowledge of
          programming languages such as HTML5, JavaScript, PHP, and CSS allows
          me to create designs that are not only aesthetically pleasing but also
          functionally effective.
        </p>
        <p className="mb-5">
          Along with this, my proficiency in content management systems (CMS)
          such as Wordpress, Drupal, ModX, Opencart, and OcStore makes me a
          multi-faceted specialist capable of implementing projects of varying
          complexity from start to finish. My goal is to provide clients with
          the highest quality design and functionality, regardless of the
          specifics of the project.
        </p>
        <p>
          Check out my{' '}
          <a
            href="https://www.linkedin.com/in/artem-hrebenko/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            LinkedIn
          </a>{' '}
          to learn more about my professional background. Thank you for visiting
          upscore.ai, and I hope our website helps you achieve your goals and
          succeed on the IELTS exam. Start improving your writing score today at{' '}
          <a
            href="/trainer"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            upscore.ai/trainer
          </a>
          !
        </p>
      </div>
    </div>
  );
};

export default ArtemTeamMember;
